import React, { useEffect, useState } from 'react';
import qs from 'qs';
import { useNavigate } from 'react-router-dom';
import { requestApi } from 'utils/request';
import TextField from 'components/TextField';
import Toggle from 'components/Toggle';
import AccountIdField from './AccountIdField';
import CheckBox from 'components/CheckBox';
import SelectManager from 'components/SelectManager';
import {
  ContentData,
  TextBox,
} from '../../../MyPage/LoanRequest/SelectManagerModal/SelectManager/style';
import { BlueLink } from '../../DataLinkageRequest/style';
import {
  DirectModalContainer,
  ReplaceModalContainer,
  DataLinkageModifyPageWrapper,
} from './style';
import ROUTE_PATH from 'routes/config';
import { COMMON_ERR_MESSAGE } from 'constants/message';
import CustomerFooter from 'components/CustomerFooter';

// 판매몰 개별 연동을 통한 데이터 연동 수정
const DataLinkageModifyPage = ({
  businessDataProviderMallMappingSeq,
  businessRegistrationNumber,
  isRepresentation,
  modalData,
  setModalData,
  setContextLoading,
}) => {
  const navigate = useNavigate();
  // 기존 연동 데이터
  const [interlockDetailData, setInterlockDetailData] = useState({});
  // 담당자 리스트
  const [managerList, setManagerList] = useState(null);
  // 2차인증 방식
  const [secondAuthMethod, setSecondAuthMethod] = useState('');

  const {
    mallName = '',
    interlockBusinessManagerName = '',
    mallInterlockStatusTypeCd = '',
    subAccountUseYn = '',
    secondAuthUseYn = '',
    mainMallId = '',
    usingSecondAuthMethodTypeCd = '',
    usingSecondAuthMethodTypeNm = '',
    mallSeq = 0,
    interlockOpenYn = '',
    secondAuthCategoryCd = '',
    delegationRequestDate = '',
    delegationRequestStatusCd = '',
  } = interlockDetailData;

  // 데이터 연동 페이지로 이동
  const goToDataLinkagePageInModifyMode = step => {
    const queryString = qs.stringify({
      mode: 'modify',
      seq: businessDataProviderMallMappingSeq,
      mallSeq: mallSeq,
      type: 'main',
    });
    navigate(
      `${ROUTE_PATH.mypage.dataLinkageDataInterlockRequest}?${queryString}`,
      {
        state: {
          step: step, // 데이터 연동 화면 진행 단계(contactStep: 2차인증 수단 입력 화면)
        },
      }
    );
  };

  // 주계정 수정 버튼 클릭/ 직접인증 설정 버튼 클릭
  const onClickAccountEditBtn = (step = '') => {
    runAfterConfirm({
      confirmFnc: () => goToDataLinkagePageInModifyMode(step),
      confirmMsg:
        '현재 연동이 중지된 상태입니다. 계정 정보를 수정하면 연동이 자동으로 다시 시도되어 연동 중지 상태가 해제됩니다. 계정 정보를 수정하시겠습니까?',
    });
  };

  // 연동 중지일 때: 확인 이후 프로세스 진행
  const runAfterConfirm = ({ confirmFnc, confirmMsg }) => {
    if (interlockOpenYn === 'Y' && mallInterlockStatusTypeCd === 'STOP') {
      setModalData({
        contents: confirmMsg,
        onClickConfirmBtn: () => {
          confirmFnc();
        },
        confirmBtnName: '확인',
        cancelBtnName: '취소',
      });
    } else {
      confirmFnc();
    }
  };

  // 담당자 정보 변경 버튼 클릭
  const onClickManagerModal = () => {
    setContextLoading(true);
    (async () => {
      await fetchManagerList();
    })();
  };

  // 토글 클릭 시, 연동 중지, 해지 모달 오픈
  const onClickToggleBtn = () => {
    setModalData({
      contents:
        mallInterlockStatusTypeCd === 'STOP'
          ? `${mallName}의 데이터 연동 중지를 해지 하시겠어요?\n해지시 해당 판매몰의 정산예정금을 활용한 대출이 가능합니다.`
          : `${mallName}의 데이터 연동 중지를 하시겠어요?\n데이터 연동을 중지한 경우 해당 판매몰의 정산예정금을 활용한 대출은 불가해요.`,
      cancelBtnName: '닫기',
      confirmBtnName:
        mallInterlockStatusTypeCd === 'STOP'
          ? '데이터 연동 중지 해지하기'
          : '데이터 연동 중지하기',
      onClickConfirmBtn: fetchDataLinkageStop,
    });
  };

  // 2차인증 방식 처리 모달 열기
  const openSecondAuthMethodModal = name => {
    // 기존 등록된 값이 없는 경우(!usingSecondAuthMethodTypeCd), 모달 오픈 시 초기값으로 셋팅
    !usingSecondAuthMethodTypeCd &&
      !secondAuthMethod &&
      setSecondAuthMethod('SMC100');

    const resetModalData = () => {
      setSecondAuthMethod('');
      setModalData(null);
    };

    switch (name) {
      case 'chooseMethod':
        setModalData({
          contents: <ChooseMethodModalContents />,
          cancelBtnName: '닫기',
          confirmBtnName: '설정하기',
          onClickConfirmBtn: () => {
            openSecondAuthMethodModal('changeToDirect');
          },
          onClickCancelBtn: resetModalData,
          onClickCloseBtn: resetModalData,
        });
        break;
      case 'changeToDirect':
        setModalData({
          contents: <ChangeToDirectModalContents />,
          cancelBtnName: '닫기',
          confirmBtnName: '직접인증 설정하기',
          onClickConfirmBtn: () =>
            goToDataLinkagePageInModifyMode('contactStep'),
          onClickCancelBtn: resetModalData,
          onClickCloseBtn: resetModalData,
        });
        break;
      case 'changeToReplace':
        setModalData({
          contents: <ChangeToReplaceModalContents />,
          cancelBtnName: '닫기',
          confirmBtnName: '대행인증 설정하기',
          onClickConfirmBtn: fetchSecondAuthAgency,
          onClickCancelBtn: resetModalData,
          onClickCloseBtn: resetModalData,
        });
        break;
    }
  };

  // 2차 인증 설정 변경 버튼 클릭
  const onClickSecondAuthBtn = name => {
    runAfterConfirm({
      confirmFnc: () => openSecondAuthMethodModal(name),
      confirmMsg: `현재 연동이 중지된 상태입니다. 2차인증 정보를 ${
        name === 'chooseMethod' ? '등록' : '수정'
      }하면 연동이 자동으로 다시 시도되어 연동 중지 상태가 해제됩니다. 2차 인증 정보를 ${
        name === 'chooseMethod' ? '등록' : '수정'
      }하시겠습니까?`,
    });
  };

  // 담당자 리스트 조회 api
  const fetchManagerList = async () => {
    try {
      const res = await requestApi({
        url: '/v1/au/manager',
        method: 'GET',
      });
      if (res.success) {
        const managerList = res.data.list
          ?.filter(
            item =>
              item?.useYn === 'Y' &&
              (item?.representationYn === 'Y' ||
                item?.invitationCompletionYn === 'Y')
          )
          .map(item => {
            return {
              businessManagerSeq: item?.businessManagerSeq,
              managerName: item?.managerName,
              mobilePhone: item?.mobilePhone,
              department: item?.department,
              position: item?.position,
              isChecked: item?.managerName === interlockBusinessManagerName, // 선택했던 이름 모달창 다시 열었을때 디폴트로 선택되기
            };
          });
        setManagerList(managerList);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setContextLoading(false);
      setModalData({
        contents: <ManagerModalContents />,
        cancelBtnName: '닫기',
        confirmBtnName: '담당자 선택',
        onClickConfirmBtn: fetchManagerChange,
      });
    }
  };

  // 담당자 변경 api
  const fetchManagerChange = async () => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider-mall/interlock/business-manager/${businessDataProviderMallMappingSeq}`,
        method: 'PUT',
        data: {
          managerName: managerList.find(item => item.isChecked).managerName,
          managerMobilePhone: managerList
            .find(item => item.isChecked)
            .mobilePhone.replaceAll('-', ''),
        },
      });

      if (res.success) {
        setModalData({
          contents: res.message,
          confirmBtnName: '확인',
          onClickConfirmBtn: () => {
            setModalData(null);
          },
        });
      }
    } catch (error) {
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
      console.error(error);
    } finally {
      (() => {
        fetchMallInterlockDetail();
      })();
    }
  };

  // 판매몰 연동 중지/해제 api
  const fetchDataLinkageStop = async () => {
    try {
      const res = await requestApi({
        url: `/v1/au/data-provider-mall/interlock-${
          mallInterlockStatusTypeCd === 'STOP' ? 'unlock' : 'lock'
        }/${businessDataProviderMallMappingSeq}`,
        method: 'PUT',
      });

      if (res.success) {
        setModalData({
          contents: res.message,
          confirmBtnName: '확인',
          onClickConfirmBtn: () => setModalData(null),
        });
      }
    } catch (error) {
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
      console.error(error);
    } finally {
      (() => {
        fetchMallInterlockDetail();
      })();
    }
  };

  // 연동 상세 정보 조회 api
  const fetchMallInterlockDetail = async () => {
    try {
      const res = await requestApi({
        url: 'v1/au/data-provider-mall/interlocked-mall-detail',
        method: 'GET',
        params: { businessDataProviderMallMappingSeq },
      });
      if (res.success) {
        setInterlockDetailData(res.data.result.interlockedMallDetail);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setContextLoading(false);
    }
  };

  // 2차 인증 대행인증 신청 api
  const fetchSecondAuthAgency = async () => {
    try {
      const res = await requestApi({
        url: `v1/au/data-provider-mall/interlock/second-auth-agency-request/${businessDataProviderMallMappingSeq}`,
        method: 'POST',
      });
      if (res.success) {
        setModalData({
          contents: res.message,
          confirmBtnName: '확인',
          onClickConfirmBtn: () => {
            setModalData(null);
            setSecondAuthMethod('');
          },
        });
      }
    } catch (error) {
      if (error.response.data.errorCode === 500) {
        setModalData({
          contents: error.response.data.message,
          onClickCloseBtn: () => {
            setModalData(null);
            setSecondAuthMethod('');
          },
        });
      } else {
        setModalData({
          contents: COMMON_ERR_MESSAGE,
        });
      }
      console.error(error);
    } finally {
      (() => {
        fetchMallInterlockDetail();
      })();
    }
  };

  // 모달 컨텐츠: '설정' 버튼 클릭
  const ChooseMethodModalContents = () => {
    return (
      <>
        <p
          style={{
            fontWeight: 700,
            fontSize: '16px',
            marginBottom: '5px',
          }}
        >
          2차인증 설정 방법을 선택해 주세요.
        </p>
        <CheckBox
          type="radio"
          name="secondAuthType"
          value="SMC100"
          text={
            <>
              <span style={{ fontWeight: 600 }}>직접 인증</span>
              <p>
                2차인증이 발생하면 고객님이 설정한 인증 방법으로 인증번호가
                전송됩니다.
              </p>
            </>
          }
          id="SMC100"
          isChecked={
            (!usingSecondAuthMethodTypeCd && !secondAuthMethod) ||
            secondAuthMethod === 'SMC100'
          }
          onChangeCheckBox={() => {
            setSecondAuthMethod('SMC100');
          }}
        />
        <CheckBox
          type="radio"
          name="secondAuthType"
          value="SMC200"
          id="SMC200"
          text={
            <>
              <span style={{ fontWeight: 600 }}>대행 인증</span>
              <p>
                2차인증이 발생하면 셀러크레딧 커넥트로 인증번호가 전송됩니다.
              </p>
            </>
          }
          isChecked={secondAuthMethod === 'SMC200'}
          onChangeCheckBox={() => {
            setSecondAuthMethod('SMC200');
          }}
        />
      </>
    );
  };

  // 모달 컨텐츠: '직접인증 변경' 버튼 클릭
  const ChangeToDirectModalContents = () => {
    return (
      <DirectModalContainer>
        2차인증을 '직접인증'으로 설정하시겠습니까? 2차인증 발생하면 고객님이
        설정한 인증 방법으로 인증번호가 전송됩니다.
        <br />
        <span>[직접인증 설정하기] 버튼</span>을 눌러 2차인증 정보를 수정해
        주세요.
      </DirectModalContainer>
    );
  };

  // 모달 컨텐츠: '대행인증 변경' 버튼 클릭
  const ChangeToReplaceModalContents = () => {
    return (
      <ReplaceModalContainer>
        <p>
          2차인증을 '대행인증'으로 설정하시겠습니까? 판매몰 어드민에 담당자
          정보를 설정하기 위해 고객님께 전화 또는 문자가 발송될 수 있습니다.
          원활한 판매몰 등록을 위한 과정이니 확인 부탁드립니다.
          <br />
          아래 내용을 확인하신 후 <span>[대행인증 설정하기] 버튼</span>을
          눌러주세요.
        </p>
        <div className="subGuide">
          <span>[대행 인증 안내]</span>
          <ul>
            <li>
              2차인증 정보를 대행인증으로 설정 시, 2차인증이 발생하면 셀러크레딧
              커넥트로 인증번호가 전송됩니다.
            </li>
            <li>
              판매몰 어드민에 셀러크레딧 담당자 정보를 입력하지 않을 경우 2차
              인증이 정상적으로 전송되지 않을 수 있습니다.
            </li>
            <li>
              셀러크레딧 커넥트는 고객님의 소중한 정보를 안전하게 보호하고
              있으며, 동의하신 인증 정보는 인증 절차 외의 다른 용도로 절대
              사용되지 않습니다.
            </li>
          </ul>
        </div>
      </ReplaceModalContainer>
    );
  };

  // 모달 컨텐츠: 담당자 선택 버튼 클릭
  const ManagerModalContents = () => {
    return (
      <>
        <SelectManager
          mallName={mallName}
          managerList={managerList}
          checkStatusList={managerList}
          setCheckStatusList={setManagerList}
          setModalData={setModalData}
        />
        {managerList?.length > 0 && (
          <TextBox style={{ margin: '30px 0' }}>
            <ContentData style={{ fontSize: '1.3rem' }}>
              선택한 담당자의 휴대폰 번호가 정확한지 확인해 주세요.
              <br />
              연동 실패나 2차 인증 필요 시 안내 문자가 발송됩니다.
              <br />
              휴대폰 번호 수정 또는 신규 담당자 추가가 필요하다면? <br />
              <BlueLink
                onClick={() => {
                  navigate(ROUTE_PATH.mypage.manager);
                }}
                target="_blank"
                tabIndex={0}
                title="직원관리 페이지로 이동"
              >
                담당자 등록(수정)하기
              </BlueLink>
            </ContentData>
          </TextBox>
        )}
      </>
    );
  };

  // 상세 정보 api 호출
  useEffect(() => {
    if (!businessDataProviderMallMappingSeq) {
      return;
    }
    (async () => {
      await fetchMallInterlockDetail();
    })();
  }, [businessDataProviderMallMappingSeq]);

  // 2차인증 모달: contents UI 업데이트
  useEffect(() => {
    secondAuthMethod &&
      setModalData({
        ...modalData,
        contents: <ChooseMethodModalContents />,
        onClickConfirmBtn: () => {
          openSecondAuthMethodModal(
            secondAuthMethod === 'SMC100' ? 'changeToDirect' : 'changeToReplace'
          );
        },
      });
  }, [secondAuthMethod]);

  // 담당자 모달: contents UI 업데이트
  useEffect(() => {
    managerList &&
      setModalData({
        contents: <ManagerModalContents />,
        cancelBtnName: '닫기',
        confirmBtnName: '담당자 선택',
        onClickConfirmBtn: fetchManagerChange,
      });
  }, [managerList]);

  return (
    <DataLinkageModifyPageWrapper>
      <div className="wrapBox">
        <h2>
          데이터 연동 정보 수정이 필요한 경우
          <br />
          수정하기를 눌러주세요.
        </h2>
        <dl>
          <dt>사업자 번호</dt>
          <dd>
            <p>{businessRegistrationNumber || '-'}</p>
          </dd>
        </dl>
        <dl>
          <dt>판매몰</dt>
          <dd>
            <TextField
              name="mallName"
              placeholder="판매몰명"
              readOnly
              value={mallName || ''}
              style={{ margin: 0 }}
            />
          </dd>
        </dl>
        {/* 계정 정보 */}
        <dl className="accountSection">
          <dt>계정 정보</dt>
          <dd>
            {subAccountUseYn !== 'Y' ? (
              <TextField
                name="mainMallId"
                placeholder="판매몰 아이디"
                value={mainMallId}
                type="text"
                readOnly
                style={{ margin: 0 }}
              />
            ) : (
              <>
                <AccountIdField
                  accountType="main"
                  interlockDetailData={interlockDetailData}
                  setModalData={setModalData}
                  runAfterConfirm={runAfterConfirm}
                />
                <AccountIdField
                  accountType="sub"
                  interlockDetailData={interlockDetailData}
                  setModalData={setModalData}
                  runAfterConfirm={runAfterConfirm}
                />
              </>
            )}
          </dd>
          <dd className="buttonGroup">
            {subAccountUseYn !== 'Y' && (
              <button
                type="button"
                onClick={onClickAccountEditBtn}
                disabled={
                  interlockOpenYn === 'Y' &&
                  mallInterlockStatusTypeCd === 'WAIT'
                }
              >
                수정
              </button>
            )}
          </dd>
        </dl>
        {/* 2차인증 정보 영역 노출: 2차인증 사용(Y)이며 문자 인증이나 이메일 인증(SAM100) */}
        {secondAuthUseYn === 'Y' && secondAuthCategoryCd === 'SAM100' && (
          <dl className="secondAuthSection">
            <dt>2차인증 정보</dt>
            <dd>
              {/* 2차인증 방식 텍스트 노출: 2차인증 방식 선택 완료(usingSecondAuthMethodTypeCd) 또는 대행인증 요청 상태(delegationRequestStatusCd === 'DRC100') */}
              {(usingSecondAuthMethodTypeCd ||
                delegationRequestStatusCd === 'DRC100') && (
                <TextField
                  name="usingSecondAuthMethodTypeNm"
                  placeholder={`2차 인증방식(${usingSecondAuthMethodTypeCd}): 고객센터로 문의 바랍니다`}
                  value={
                    delegationRequestStatusCd === 'DRC100'
                      ? `대행인증 요청 완료(${delegationRequestDate?.replaceAll(
                          '-',
                          '.'
                        )})`
                      : usingSecondAuthMethodTypeNm
                  }
                  readOnly
                  style={{ margin: '0' }}
                />
              )}
            </dd>
            <dd className="buttonGroup">
              <button
                type="button"
                onClick={() => {
                  // 설정(chooseMethod): 기존 설정된 값이 없고(!usingSecondAuthMethodTypeCd) 대행인증 요청 상태(DRC100)가 아닌 경우
                  onClickSecondAuthBtn(
                    !usingSecondAuthMethodTypeCd &&
                      delegationRequestStatusCd !== 'DRC100'
                      ? 'chooseMethod'
                      : usingSecondAuthMethodTypeCd === 'SMC100' ||
                        delegationRequestStatusCd === 'DRC100'
                      ? 'changeToReplace'
                      : 'changeToDirect'
                  );
                }}
                disabled={
                  (interlockOpenYn === 'Y' &&
                    mallInterlockStatusTypeCd === 'WAIT') ||
                  delegationRequestStatusCd === 'DRC100'
                }
              >
                {/* 설정(chooseMethod): 기존 설정된 값이 없고(!usingSecondAuthMethodTypeCd) 대행인증 요청 상태(DRC100)가 아닌 경우 */}
                {!usingSecondAuthMethodTypeCd &&
                delegationRequestStatusCd !== 'DRC100'
                  ? '설정'
                  : usingSecondAuthMethodTypeCd === 'SMC100' ||
                    delegationRequestStatusCd === 'DRC100'
                  ? '대행인증 변경'
                  : '직접인증 변경'}
              </button>
            </dd>
          </dl>
        )}
        {/* 담당자 수정 */}
        <dl>
          <dt>연동 결과 안내 담당자</dt>
          <dd>
            <TextField
              name="interlockBusinessManagerName"
              placeholder="데이터 연동 담당자"
              value={interlockBusinessManagerName}
              readOnly
              style={{ margin: '0 0 23px' }}
            />
          </dd>
          <dd className="buttonGroup">
            {isRepresentation && (
              <button type="button" onClick={onClickManagerModal}>
                수정
              </button>
            )}
          </dd>
        </dl>
        {/* 데이터 연동 중지 및 중지해지 */}
        <section>
          <p className="title">데이터 연동 중지가 필요하신가요?</p>
          <p className="description">
            판매몰의 연동 정보를 잠시 중지할 수 있습니다. 단, 데이터 연동을
            중지한 경우 해당 판매몰의 정산예정금을 활용한 대출은 불가하며,
            금융기관에 데이터를 제공할 수 없습니다.
          </p>
          <Toggle
            toggleName="stopDataLinkage"
            toggleChecked={mallInterlockStatusTypeCd === 'STOP'}
            onChangeToggle={onClickToggleBtn}
          />
        </section>
      </div>
      <CustomerFooter />
    </DataLinkageModifyPageWrapper>
  );
};

export default DataLinkageModifyPage;
